/**
 * @generated SignedSource<<d1cf30b7372ff6a2a560ff24540a9700>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedRecentSales_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedRelatedItemsSection_viewer">;
  readonly " $fragmentType": "SharedRecentSales_viewer";
};
export type SharedRecentSales_viewer$key = {
  readonly " $data"?: SharedRecentSales_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedRecentSales_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedRecentSales_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRelatedItemsSection_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "7c4815775263df93b67c053ab2db58b7";

export default node;
